import { Button, Form, Input } from 'antd'
import { Link, Navigate, useLocation } from 'react-router-dom'

import { useAuth } from '@/hooks/useAuth'
import { Logo } from '@/components/logo'
import { PWD_RESET_URL, SIGNIN_FORM_FIELDS } from '@/constants'
import { AltchaState, AuthState } from '@/state'

import { AltchaComponent } from '@/components/altcaptcha'
import React from 'react'
import { OfflineState } from '@/state/offline-management'
import './index.scss'

export const SignInPage: React.FC = () => {
  const location = useLocation()

  const { from } = location.state ?? { from: { pathname: '/' } }
  const { handleLogin, isLoading } = useAuth()

  const [signinForm] = Form.useForm()

  const usernameValue: string = Form.useWatch(
    SIGNIN_FORM_FIELDS.username.value,
    signinForm
  )
  const passwordValue: string = Form.useWatch(
    SIGNIN_FORM_FIELDS.password.value,
    signinForm
  )

  if (AuthState.isLoggedIn.value) return <Navigate replace to={from} />

  const submitBtnEnabled = !!usernameValue?.length && !!passwordValue?.length

  return (
    <div className='signin-page'>
      <Logo />
      <Form form={signinForm} className='signin-form' onFinish={handleLogin}>
        <Form.Item
          hasFeedback
          required
          name={SIGNIN_FORM_FIELDS.username.value}
          rules={[
            {
              message: 'Por favor ingrese el usuario',
              required: true,
            },
          ]}
        >
          <Input
            autoComplete={SIGNIN_FORM_FIELDS.username.value}
            className='username-input'
            placeholder={SIGNIN_FORM_FIELDS.username.label}
            size='large'
          />
        </Form.Item>

        <Form.Item
          hasFeedback
          name={SIGNIN_FORM_FIELDS.password.value}
          required
          rules={[
            {
              message: 'Por favor ingrese la contraseña',
              required: true,
            },
          ]}
        >
          <Input.Password
            autoComplete='current-password'
            className='password-input'
            placeholder={SIGNIN_FORM_FIELDS.password.label}
            size='large'
            visibilityToggle
          />
        </Form.Item>

        {OfflineState.isOnline.value && (
          <Link className='pwd-reset-link' to={PWD_RESET_URL} target='_blank'>
            ¿Olvidaste tu contraseña?
          </Link>
        )}

        {OfflineState.isOnline.value && <AltchaComponent id='altcha-login' />}

        <Button
          className='submit-btn'
          htmlType='submit'
          loading={isLoading.value}
          disabled={
            !submitBtnEnabled ||
            isLoading.value ||
            (!AltchaState.altcha.value && OfflineState.isOnline.value)
          }
          type='primary'
        >
          Iniciar Sesión
        </Button>
      </Form>
    </div>
  )
}
